export default __webpack_public_path__ + "static/media/bg.9c5a7fc7.webp";